import React, { createContext, useContext, ReactNode } from 'react';
import { ChildrenContext } from './Children.tsx';
export function ComposerChildren({ groupName, children }) {
    let context = useContext(ChildrenContext)
    let content : React.ReactElement[] | null = context.content
    
    /** Reset context and return children  */
    return <ChildrenContext.Provider value={{ name: "", id: null, depth: 0, content: [], attributes: {} }}>{content}</ChildrenContext.Provider> 
}